import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../translation/translation_container';
import Submit from '../form/floating_label/submit';
import Translation from '../translation/translation';
import { Filters } from '../../constants/filter/filters';
import Select from '../form/floating_label/select';
import TextInput from '../form/floating_label/text_input';
import VehicleList from './confirmation_layer/vehicle_list';
import { getDefaultValueForFilter } from '../../helper/filters/get_default_value_for_filter';
import VehicleConfiguratorButton from '../configurator_buttons/vehicle_configurator';
import MotoTyreSizeConfiguratorButton from '../configurator_buttons/moto_tyre_size_configurator';
import TyreSizeConfiguratorButton from '../configurator_buttons/tyre_size_configurator';
import PostcodeAutocomplete, { showAutoCompletePostcodeSelector } from '../PostcodeAutocomplete';
import getTranslatedText from '../../helper/get_translated_text';
import CantProvideVehicle from '../configurator/cant_provide_vehicle';
import { onShowInfoClick } from '../../../_views/configurator/on_show_info';
import ConfiguratorFindSizeInfoLayer from './configurator_find_size_info_layer';

function ConfirmationLayer(props) {
  const {
    vehicleData,
    filters,
    tyreOptions,
    onChange,
    isCheckoutConfigurator,
    isRegoLookupV2,
    onChangeCantProvideVehicle,
    fromTyreSize,
  } = props;
  const submitContainerClassNames = [
    'rego-lookup-configurator-submit-section',
    'rego-lookup-configurator-input-section',
  ];
  const submitDisabled = !filters.registration || props.buttonConfirmDisabled;
  const shopDisabled = !filters.postcode || !filters.tyres;
  const VEHICLE_TYRES = Filters.VEHICLE_TYRES;
  const vehicleTyresIsEmpty = tyreOptions.length <= 0;
  const translationConfirmationHeader =
    vehicleData.length === 1
      ? 'rego-lookup-confirmation-layer-header-text'
      : 'rego-lookup-confirmation-layer-header-text-multiple-match';
  const translationConfirmationContent =
    vehicleData.length === 1
      ? 'rego-lookup-confirmation-layer-content-text'
      : 'rego-lookup-confirmation-layer-content-text-multiple-match';
  const tyresHasValue = getDefaultValueForFilter(VEHICLE_TYRES) !== filters[VEHICLE_TYRES];
  const showPostcodeAndCitySelector = showAutoCompletePostcodeSelector(props.store);
  return (
    <span>
      <div className="rego-lookup-configurator-confirmation-layer-header">
        <Translation translationKey={translationConfirmationHeader} />
      </div>
      <div className="rego-lookup-configurator-confirmation-layer-sub-header">
        <Translation translationKey={translationConfirmationContent} />
      </div>
      <div className="rego-lookup-configurator-confirmation-layer-confirmation">
        <p className="head">
          <Translation translationKey={'rego-lookup-confirmation-layer-label-registration'} />
          <strong style={{ textTransform: 'uppercase' }}>
            &nbsp;{filters[Filters.REGISTRATION]}, {filters['state']}
          </strong>
          <a href="#" onClick={props.onEdit}>
            <Translation className="edit" translationKey={'rego-lookup-confirmation-layer-edit-label'} />
          </a>
        </p>

        <VehicleList vehicleData={vehicleData} onSelectVehicle={props.onSelectVehicle} />
      </div>
      <form
        className="rego-lookup-confirmation-layer rego-lookup-configurator-section"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        {isCheckoutConfigurator && props.buttonConfirmIsShown && (
          <TranslationContainer targetProperty="label" translationKey="vehicle-configurator-submit-label-partial">
            <Submit
              onSubmit={props.onSubmitShop}
              label="will-be-replaced"
              call-to-action={true}
              disabled={submitDisabled}
            />
          </TranslationContainer>
        )}

        {!isCheckoutConfigurator && props.buttonConfirmIsShown && (
          <div className={submitContainerClassNames.join(' ')}>
            <TranslationContainer
              targetProperty="label"
              translationKey="rego-lookup-confirmation-layer-button-confirm-label"
            >
              <Submit
                onSubmit={props.onShowTyres}
                label="will-be-replaced"
                call-to-action={true}
                disabled={submitDisabled}
              />
            </TranslationContainer>
          </div>
        )}

        {!isCheckoutConfigurator && !props.buttonConfirmIsShown && !vehicleTyresIsEmpty && (
          <>
            <ConfiguratorFindSizeInfoLayer type="rego" heading={true} />

            <TranslationContainer
              targetProperties={{
                label: { translationKey: 'rego-lookup-confirmation-layer-tyres-label' },
              }}
            >
              <Select
                name={VEHICLE_TYRES}
                value={filters.tyres}
                hasValue={filters.tyres.length > 0}
                options={tyreOptions}
                onChange={onChange}
                label="will-be-replaced"
                highlight={true}
                loading={false}
                invalid={false}
                required={true}
                disabled={false}
                additionalClassNames={['input-postcode']}
              />
            </TranslationContainer>
          </>
        )}
        
        {!isCheckoutConfigurator && !props.buttonConfirmIsShown && !tyresHasValue && (
          <ConfiguratorFindSizeInfoLayer type="rego" text={true} />
        )}

        {!isCheckoutConfigurator && !props.buttonConfirmIsShown && tyresHasValue && (
          <div className="configurator-not-sure-size">
            <ConfiguratorFindSizeInfoLayer type="rego" text={true} isInnerText={true} />
            <div className="rego-lookup-configurator-confirmation-layer-confirmation-info">
              <p className="note">
                <Translation translationKey={'rego-lookup-confirmation-layer-double-check-your-selection'} />
                &nbsp;
                <a onClick={props.onShowInfo}>
                  <Translation translationKey={'rego-lookup-confirmation-layer-double-check-click-here'} />
                </a>
              </p>
            </div>
          </div>
        )}
        {!isCheckoutConfigurator &&
          !props.buttonConfirmIsShown &&
          !vehicleTyresIsEmpty &&
          !showPostcodeAndCitySelector && (
            <TranslationContainer
              targetProperties={{
                label: { translationKey: 'rego-lookup-input-layer-input-postcode-label' },
              }}
            >
              <TextInput
                name="postcode"
                value={filters.postcode}
                onChange={onChange}
                label="will-be-replaced"
                highlight={true}
                disabled={false}
                invalid={props.postcodeInvalid}
                additionalClassNames={['input-postcode']}
                onBlur={props.onBlur}
              />
            </TranslationContainer>
          )}

        {!isCheckoutConfigurator &&
          !props.buttonConfirmIsShown &&
          !vehicleTyresIsEmpty &&
          showPostcodeAndCitySelector && (
            <PostcodeAutocomplete
              onChange={onChange}
              name="postcode"
              value={filters.postcode}
              selectSuggestion={props.selectPostcodeSuggestion}
              minLength={3}
            >
              <TextInput
                name="postcode"
                value={filters.postcode}
                onChange={onChange}
                label={getTranslatedText('rego-lookup-input-layer-input-postcode-label')}
                highlight={true}
                disabled={false}
                invalid={props.postcodeInvalid}
                additionalClassNames={['input-postcode']}
                autoComplete="off"
                errorText={getTranslatedText('postcode-autosuggest-select-from-list')}
                onBlur={props.onBlur}
              />
            </PostcodeAutocomplete>
          )}

        {!isCheckoutConfigurator && !props.buttonConfirmIsShown && !vehicleTyresIsEmpty && (
          <TranslationContainer
            targetProperty="label"
            translationKey="rego-lookup-confirmation-layer-button-cta-buy-label"
          >
            <Submit
              onSubmit={props.onSubmitShop}
              label="will-be-replaced"
              call-to-action={true}
              disabled={shopDisabled}
            />
          </TranslationContainer>
        )}

        {!props.buttonConfirmIsShown && vehicleTyresIsEmpty && (
          <div className="rego-lookup-confirmation-layer-tyre-not-found">
            <Translation translationKey={'rego-lookup-confirmation-layer-no-tyre-for-vehicle'} />
          </div>
        )}

        <div className="rego-lookup-configurator-confirmation-layer-confirmation-info-alternative">
          <p>
            <Translation translationKey={'rego-lookup-confirmation-layer-not-your-vehicle'} />
          </p>
          <div className="configurator-alternative-container">
            <VehicleConfiguratorButton isVisibleV2={isRegoLookupV2} fromTyreSize={fromTyreSize} />
            {!isCheckoutConfigurator && <TyreSizeConfiguratorButton />}
            {!isCheckoutConfigurator && props.configuratorMotoTyreEnabled && <MotoTyreSizeConfiguratorButton />}
          </div>
        </div>
        {isCheckoutConfigurator && (
          <CantProvideVehicle
            id="cant-provide-vehicle-rego-confirmation-layer"
            onChangeCantProvideVehicle={onChangeCantProvideVehicle}
          />
        )}
      </form>
    </span>
  );
}

ConfirmationLayer.propTypes = {
  filters: PropTypes.object.isRequired,
  vehicleData: PropTypes.array.isRequired,
  tyreOptions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmitShop: PropTypes.func.isRequired,
  postcodeInvalid: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onShowTyres: PropTypes.func.isRequired,
  buttonConfirmIsShown: PropTypes.bool.isRequired,
  onShowInfo: PropTypes.func.isRequired,
  onSelectVehicle: PropTypes.func.isRequired,
  buttonConfirmDisabled: PropTypes.bool.isRequired,
  configuratorMotoTyreEnabled: PropTypes.bool,
};

ConfirmationLayer.defaultProps = {
  configuratorMotoTyreEnabled: false,
};

export default ConfirmationLayer;
